/** @jsx jsx */

import { useEffect, useState } from 'react';

import { jsx } from '@emotion/core';

import CodeEditor from 'app/developer-v3/components/CodeEditor';
import { prettyFormatJsonString } from 'app/developer-v3/utils';

type Props = {
  initValue: {};
  onBlur: (value?: {}) => void;
  placeholder: string;
};

function Code({ initValue, onBlur, placeholder }: Props) {
  const [value, setValue] = useState<string>(prettyFormatJsonString(initValue));

  useEffect(() => {
    setValue(prettyFormatJsonString(initValue));
  }, [initValue]);

  const onBlurEditor = () => {
    try {
      onBlur(value === '' ? undefined : JSON.parse(value));
    } catch (error) {
      // Eaten. Ace has displayed errors.
    }
  };

  return (
    <CodeEditor
      height="100%"
      maxLines={20}
      minLines={3}
      mode="json"
      onBlur={onBlurEditor}
      onChange={setValue}
      placeholder={placeholder}
      shouldShowLineNumbers={false}
      value={value}
      width="100%"
    />
  );
}

export default Code;
